import { h } from 'preact'
import { CampaignType, GraphQLError } from 'scripts/type'
import { ERROR_CAMPAIGN_CLOSED, ERROR_SUBSCRIPTION_BALANCE_INSUFFICIENT } from 'scripts/constants'
import BalanceInsufficient from './BalanceInsufficient'
import NotFound from './NotFound'
import Closed from './Closed'

interface Props {
  error: GraphQLError
  campaignType: CampaignType
}

export default function ErrorPage({ error, campaignType }: Props) {
  const { message, extensions } = error
  if (message === ERROR_SUBSCRIPTION_BALANCE_INSUFFICIENT) {
    return <BalanceInsufficient />
  }
  const errorCode = extensions?.code ?? 'error'
  if (errorCode === ERROR_CAMPAIGN_CLOSED) {
    return <Closed campaignType={campaignType} />
  }
  return <NotFound campaignType={campaignType} />
}
